export enum ProjectLinkObjectType {
  Entity = 'Entity',
  GitRepository = 'GitRepository',
  GitFile = 'GitFile',
  External = 'External',
}
